import * as React from 'react';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'shared/utils/hooks/useRedux';
import { useFormRedux } from 'shared/utils/hooks/useFormRedux';
import * as yup from 'yup';
import { DocumentStep } from './ui/DocumentStep';
import { updateField } from 'entities/cancer-protection/step-3';
import { validationSchema } from 'entities/cancer-protection/step-3/utils/validationSchema';
import { policyTemplate } from 'entities/cancer-protection/step-3/selector';
import { fetchPolicyTemplate, fetchTextInfo } from 'entities/cancer-protection/step-3/action/fetch-step-tree';
import Loader from 'shared/loader/Loader';
import { Pay } from './ui/Pay';
import { FormFieldsStepOne } from 'entities/cancer-protection/step-1/selector';

interface IPropsStepTree {
    windowWidth: number;
    handleNext: () => void;
    setTriggerPay: (value: boolean) => void;
}

enum Steps {
    DocumentStep = "DocumentStep",
    FinalSum = 'FinalSum',
    Pay = 'Pay'
}

export const StepTree: React.FC<IPropsStepTree> = ({ windowWidth, handleNext, setTriggerPay }) => {
    const dispatch = useAppDispatch();
    const [currentStep, setCurrentStep] = useState<Steps>(Steps.DocumentStep);
    const { AgentSalesDataID } = useAppSelector(FormFieldsStepOne);

    const [errorsValidate, setErrorsValidate] = useState<Record<string, string>>({});

    const validateAgree = async () => {
        try {
            await validationSchema.validate(formState, { abortEarly: false });
            setErrorsValidate({});
            return true;
        } catch (err) {
            if (err instanceof yup.ValidationError) {
                const newErrors: Record<string, string> = {};
                err.inner.forEach((error) => {
                    if (error.path) {
                        newErrors[error.path] = error.message;
                    }
                });
                setErrorsValidate(newErrors);
                return false;
            }
            return false;
        }
    };

    const handleNextStep = async () => {
        let isValid = false;
        switch (currentStep) {
            case Steps.DocumentStep:
                isValid = await validateAgree();
                if (isValid) setCurrentStep(Steps.Pay);
                break;
            default:
                break;
        }
    };

    const handleBack = () => {
        switch (currentStep) {
            case Steps.Pay:
                setCurrentStep(Steps.DocumentStep)
                break;
            default:
                break;
        }
    };
    const {
        formState,
        errors,
        handleCheckboxChange
    } = useFormRedux(
        (state) => state.StepTreeCancer,
        updateField,
        validationSchema
    );
    useEffect(() => {
        dispatch(fetchPolicyTemplate({ AgentSalesDataID: AgentSalesDataID }));
        dispatch(fetchTextInfo({ AgentSalesDataID: AgentSalesDataID }));
    }, [])
    const { isLoadingPolicyTemplate, PolicyTemplateDataBase64, errorsPolicyTemplate } = useAppSelector(policyTemplate);

    const handleOpenPolicy = () => {
        if (!PolicyTemplateDataBase64) {
            console.error("Нет данных для открытия полиса.");
            return;
        }
        try {
            const byteCharacters = atob(PolicyTemplateDataBase64);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const blobUrl = URL.createObjectURL(blob);
            window.open(blobUrl, '_blank');
        } catch (error) {
            console.error("Ошибка при открытии полиса:", error);
        }
    };
    if (isLoadingPolicyTemplate) {
        return <Loader title="Пожалуйста подождите..." />;
    }
    return (
        <>
            {currentStep === Steps.DocumentStep && (
                <DocumentStep
                    formState={formState}
                    errors={errors}
                    handleNextStep={handleNextStep}
                    handleCheckboxChange={handleCheckboxChange}
                    handleOpenPolicy={handleOpenPolicy}
                    errorsValidate={errorsValidate}
                    windowWidth={windowWidth}
                    handleNext={handleNext}
                />
            )}
            {currentStep === Steps.Pay && (
                <Pay
                    handleBack={handleBack}
                    windowWidth={windowWidth}
                    handleNextStep={handleNextStep}
                    handleNext={handleNext}
                    setTriggerPay={setTriggerPay}
                />
            )}
        </>

    );
};